import { CryptoStorage } from 'libs/storage/src/lib/utils/crypto-storage';
import { MemoryStorage } from './memory-storage';

export class StorageFactory {
  private static _localStorageMock = new MemoryStorage();
  private static _sessionStorageMock = new MemoryStorage();

  public static get localStorage(): Storage {
    return window?.localStorage || StorageFactory._localStorageMock;
  }

  public static get sessionStorage(): Storage {
    return window?.sessionStorage || StorageFactory._sessionStorageMock;
  }

  public static createCryptoStorage(version: string, secretKey: string, storage: Storage = StorageFactory.localStorage) {
    return new CryptoStorage(storage, version, secretKey);
  }
}
